module.exports = __webpack_public_path__ + "static/media/avatar_default.27b9408d.png";